import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiEndpoints } from '../../config/api-endpoints';
import { environment } from '../../environments/environment';
 
@Injectable({
  providedIn: 'root'
})

export class AddressValidationService {
  constructor(private http: HttpClient) {}
 
  private getAuthOptions() {
    let token = '';
    try {
      const sessionData = sessionStorage.getItem('data');
      if (sessionData) {
        const parsedSession = JSON.parse(sessionData);
        token = parsedSession.__raw || parsedSession.token || '';
      }
    } catch (error) {
      console.error('Error retrieving session token for address validation:', error);
    }
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    };
  }
 
  public validateAddress(payload: any): Observable<any> {
    return this.http.post<any>(
      `${environment.baseUrl.api}${ApiEndpoints.ADDRESS_VALIDATION}`,
      payload,
      this.getAuthOptions()
    );
  }
}
 